import { Radio } from 'antd';
import S from './styles';

const CreditItem = ({ creditData }) => {
  const { id, credits, totalAmount, savings } = creditData;

  return (
    <S.Container>
      <Radio value={id}>
        <S.CreditWrapper>
          <S.Credit>{credits} Book Credits</S.Credit>
          <S.Description>Save ${savings}</S.Description>
        </S.CreditWrapper>
      </Radio>
      <S.Price>${totalAmount}</S.Price>
    </S.Container>
  );
};

export default CreditItem;
